// Checkout Forms
import { FIRST_NAME_DATA_STANDARDS, LAST_NAME_DATA_STANDARDS } from 'checkout-forms/form/fields';
import getAddressFieldsConfig from 'checkout-forms/form/configs/address';

// Config
import { countryCodeIsInternational } from '@utils/address/addressHelpers';
import makePostcodeOptional from '@utils/address/makePostcodeOptional';
import makePostcodeReadOnly from '@utils/address/makePostcodeReadOnly';
import getInternationalPhoneNumberConfig from '@utils/lazy/internationalPhoneNumberConfig';

export const PAYPAL_BILLING_ADDRESS_FORM_ID = 'paypalBillingDetailsForm';
export const PAYPAL_SHIPPING_ADDRESS_FORM_ID = 'paypalShippingDetailsForm';

export const FORM_ID = {
  billing: PAYPAL_BILLING_ADDRESS_FORM_ID,
  shipping: PAYPAL_SHIPPING_ADDRESS_FORM_ID,
};

// TODO could this be subsumed into billingAddress.js?
export default function getPayPalAddressDetailsFormConfig(params) {
  const {
    countryCode,
    addressLines = 3,
    maxAddressLines,
    actions,
    configExtras = {},
    international,
    enableGBCounty,
    isPaypalExpress,
    isSimplePhoneNumberFeatureActive,
  } = params;

  const { addressType = 'billing', isClickCollectOrder, submitButtonExtra } = configExtras;
  let ADDRESS_FIELDS = getAddressFieldsConfig({
    international,
    countryCode,
    addressLines,
    maxAddressLines,
    actions,
    configExtras,
    allowAsciiOnly: true,
    enableGBCounty,
  });

  if (isPaypalExpress && addressType === 'shipping') {
    ADDRESS_FIELDS = ADDRESS_FIELDS.map((field) => {
      if (!field?.required) return field;

      return {
        ...field,
        minLength: 2, // Validates that the field has at least 2 characters for error handling
        validationMessageKeys: {
          ...field.validationMessageKeys,
          minLength: 'Sorry, this line is too short. Please enter at least 2 characters.',
        },
        extensionProps: {
          ...field.extensionProps,
          minLength: 2, // Ensures a min length value on the input field
        },
      };
    });
  }

  const PHONE_NUMBER = getInternationalPhoneNumberConfig({
    isClickCollectOrder,
    isSimplePhoneNumberFeatureActive,
    showDefaultInstruction: true,
  });

  const postcodeOptional = countryCodeIsInternational(countryCode);
  if (postcodeOptional) {
    makePostcodeOptional(ADDRESS_FIELDS);
  }

  if (isPaypalExpress) {
    makePostcodeReadOnly(ADDRESS_FIELDS);
  }

  return {
    submitButton: 'Continue with payment',
    submitButtonExtra,
    id: FORM_ID[addressType],
    fields: [FIRST_NAME_DATA_STANDARDS, LAST_NAME_DATA_STANDARDS, PHONE_NUMBER, ...ADDRESS_FIELDS],
  };
}
